import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://vantage-production-4475.up.railway.app/api'

const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Channels
export const getChannels = () => api.get('/channels/');
export const getChannel = (id) => api.get(`/channels/${id}`);
export const createChannel = (data) => api.post('/channels/', data);
export const updateChannel = (id, data) => api.put(`/channels/${id}`, data);
export const deleteChannel = (id) => api.delete(`/channels/${id}`);
export const toggleChannel = (id) => api.post(`/channels/${id}/toggle`);

// Videos
export const getVideos = (params) => api.get('/videos/', { params });
export const getVideo = (id) => api.get(`/videos/${id}`);

export const uploadVideo = async (videoData, onProgress, onXhrReady) => {
  try {
    let filePath = '';
    let fileName = '';

    if (videoData.file) {
      const formData = new FormData();
      formData.append('file', videoData.file);

      await new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        if (onXhrReady) onXhrReady(xhr);
        xhr.open('POST', 'https://vantage-production-4475.up.railway.app/api/upload-file');
        xhr.upload.onprogress = (e) => {
          if (e.lengthComputable && onProgress) {
            const percent = Math.round((e.loaded / e.total) * 100);
            onProgress(percent);
          }
        };
        xhr.onload = () => {
          try {
            const data = JSON.parse(xhr.responseText);
            if (data.success) {
              filePath = data.data.filepath;
              fileName = data.data.original_name;
              resolve();
            } else {
              reject(new Error(data.message || 'Upload failed'));
            }
          } catch (e) {
            reject(new Error('Upload failed'));
          }
        };
        xhr.onerror = () => reject(new Error('Upload failed'));
        xhr.onabort = () => reject(new Error('Upload cancelled'));
        xhr.send(formData);
      });
    }

    const videoPayload = {
      ...videoData,
      file_path: filePath,
      file_name: fileName
    };
    delete videoPayload.file;
    return await api.post('/videos/', videoPayload);
  } catch (error) {
    throw error;
  }
};

export const updateVideo = (id, data) => api.put(`/videos/${id}`, data);
export const deleteVideo = (id) => api.delete(`/videos/${id}`);
export const updateMetadata = (id, data) => api.post(`/videos/${id}/metadata`, data);
export const updateStatus = (id, data) => api.post(`/videos/${id}/status`, data);

// Schedules
export const getSchedules = (params) => api.get('/schedules/', { params });
export const createSchedule = (data) => api.post('/schedules/', data);
export const updateSchedule = (id, data) => api.put(`/schedules/${id}`, data);
export const deleteSchedule = (id) => api.delete(`/schedules/${id}`);
export const getUpcomingSchedules = () => api.get('/schedules/upcoming');

// Analytics
export const getOverview = () => api.get('/analytics/overview');
export const getChannelAnalytics = (id) => api.get(`/analytics/channels/${id}`);
export const getPlatformAnalytics = () => api.get('/analytics/platforms');
export const getUploadStrategy = (id) => api.get(`/analytics/strategy/${id}`);

export default api;